import { View } from '@lernetz/ts-lib';

import { Answer } from './Answer';
import { Slide } from './Slide';

import template from './Question.html';
import { Subscription } from '@lernetz/ts-lib/src/Signal';


type QuestionType = '-single-choice' | '-multiple-choice';


export class Question extends Slide {

    public readonly answers: Answer[];
    public correctlyAnswered: boolean;
    public readonly text: string;
    public readonly type: QuestionType;

    constructor( dto: object ) {
        super({
            answers: [],
            correctlyAnswered: false,
            text: '',
            type: '-multiple-choice',
            ...dto,
        });

        for (const answer of this.answers) {
            answer.type = this.type;
            if (this.type === '-single-choice') {
                answer.propertyChange.filter(property => property.name === 'selected' && answer.selected).subscribe(() => this.onAnswerSelected(answer));
            }
            answer.propertyChange.subscribe( () => this.updateState() );
        }
        this.propertyChange.subscribe( () => this.updateState() );
    }

    onAnswerSelected(answer: Answer) {
        if (!answer || !this.answers) return;

        if (this.type === '-single-choice') {
            for (const a of this.answers) {
                if (a !== answer) {
                    a.selected = false;
                }
            }
        }
    }

    updateState() {
        this.hasInput = this.answers.some( a => a.selected );
        this.correctlyAnswered = this.answers.every( a => a.correctlyAnswered );
        for( const answer of this.answers ) {
            answer.evaluated = this.evaluated;
        }
    }
}


export class QuestionView extends View<Question> {

    private subscription: Subscription;

    constructor() {
        super({ template });
    }

    init() {
        this.subscription = this.data.propertyChange.filter( p => p.name === 'evaluated' ).subscribe( () => this.scrollToFeedback() );
        if( this.data.evaluated ) {
            this.scrollToFeedback();
        }
    }

    deinit() {
        this.subscription?.unsubscribe();
    }

    private scrollToFeedback() {
        if( this.data.evaluated ) {
            const feedbackNode = this.node.querySelector( '.feedback' );
            feedbackNode?.scrollIntoView( { behavior: 'smooth' } );
        }
    }
}
